import { ref } from 'vue'
import { useApi } from '@/functions/api'

type Dashboard = {
  products_count: number,
  product_variants_count: number,
  last_stock_opname: {
    id: number,
    ended_at: string | null,
  } | null,
}

export function useDashboard () {

  const dashboardData = ref<Dashboard>()
  const api = useApi()

  const getData = async () => {
    const response = await api.GET<Dashboard>('/warehouse/dashboard')
    dashboardData.value = response
  }

  return {
    getData,
    dashboardData,
  }
}
